import React, { memo } from 'react';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import Col from '../Utils/Col/Col';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';
import Image from '../Image/Image';
import Video from '../Video/Video';
import FiftyFiftyProps from '../FiftyFifty.interface';
import classNames from 'classnames';
import SbImage from '../SbImage/SbImage';

const FiftyFifty: React.FC<FiftyFiftyProps> = ({
  blok: { media, reverse, is_bottom_padding_required = true },
  children,
}) => {
  return (
    <Container>
      <div
        className={classNames('pt-20', {
          'pb-20 sm:pb-36': is_bottom_padding_required,
        })}
      >
        <Grid className="xl:grid-flow-col-dense" gapY={'gap-y-14 sm:gap-y-20'}>
          <Col span={{ xl: 5 }} start={{ xl: reverse ? 1 : 8 }}>
            <div className="flex items-center h-full">
              {media && media[0]?.image && (
                <SbImage
                  asset={media[0].image}
                  options={{ width: 900, sizes: { base: 1600 } }}
                />
              )}
              {media && media[0]?.video_id && media[0]?.video_thumbnail && (
                <Video
                  blok={{
                    video_thumbnail: media[0].video_thumbnail,
                    video_id: media[0].video_id,
                    structured_data: media[0].structured_data,
                    className: 'w-full md:w-[548px] xl:w-auto mx-auto !block',
                  }}
                />
              )}
            </div>
          </Col>
          <Col span={{ xl: 6 }} start={{ xl: reverse ? 7 : 1 }}>
            <div className="flex items-center h-full">{children}</div>
          </Col>
        </Grid>
      </div>
    </Container>
  );
};

export default memo(withBlokWrapper(FiftyFifty));
